import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApproveModel } from './approve.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApproveService {

  constructor(private http: HttpClient) { }

  public getPendingWithdraw()
  {
    return this.http.get<ApproveModel[]>(`${environment.apiUrl}/getPendingWithdraw`);
  }

  public approveOrNotWithdraw(ids: string[], isApproved: boolean, code2FA: string)
  {
    return this.http.post(`${environment.apiUrl}/approveWithdraw`, {ids,isApproved,code2FA});
  }
}
